const $ = require('jquery');

window.$ = window.jQuery = $;

window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
window.bootstrap = require('@fancyapps/fancybox/dist/jquery.fancybox.min');

//Buscador
$('.buscador').click(function (e) {
    e.preventDefault();
    $('body').addClass('overflow-hidden');
    $('.search-fixed').fadeIn();
    $('.search-field').focus();
});
$('.cerrar-buscador').click(function (e) {
    e.preventDefault();
    $('body').removeClass('overflow-hidden');
    $('.search-fixed').fadeOut();
});
//Menú
$('.navbar-toggler').click(function (e) {
    e.preventDefault();
    $('body').addClass('overflow-hidden');
    $('.menu-lateral').fadeIn();
});
$('.cerrar-menu').click(function (e) {
    e.preventDefault();
    $('body').removeClass('overflow-hidden');
    $('.menu-lateral').fadeOut();
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

//Envío del formulario de newsletter
$('#formNewsletter').on('submit', function (e) {
    e.preventDefault();
    $('#infoNewsletter').html('<span class="d-block text-center mt-3"><i class="fa-solid fa-spinner fa-pulse me-2"></i> Enviando...</span>');
    let action = $(this).attr('action');
    let email = $('#newsletter_email');

    $.ajax({
        url: action,
        type: 'POST',
        data: {
            email: email.val()
        },
    }).done(function (response) {
        email.val('');
        $('#infoNewsletter').html('<span class="d-block text-center mt-3"><span class="text-success"><i class="fa-solid fa-check me-2"></i> ' + response.success + '</span></span>');
    }).fail(function (response) {
        $('#infoNewsletter').html('<span class="d-block text-center mt-3"><span class="text-danger"><i class="fa-solid fa-xmark me-2"></i> ' + response.responseJSON.errors.email + '</span></span>');
    });
});

//Botón Filtrar
let click = 0;
$('.filtrando-tipo .btn').click(function (e) {
    e.preventDefault();
    if (click === 0) {
        $('.filtrando-tipo .listado').css({'display': 'block'});
        $('.filtrando-tipo .btn').css('color', '#a9a5a5');
        click = 1;
    } else {
        $('.filtrando-tipo .listado').css('display', 'none');
        $('.filtrando-tipo .btn').css('color', '#000000');
        click = 0;
    }
});

//Calendario
let clickCalendario = 0;

$('.filtrar-fecha > a').click(function (e) {
    e.preventDefault();
    if (clickCalendario == 0) {
        $('#calendar').removeClass('d-none').addClass('d-block');
        showCalendar();
        clickCalendario = 1;
    } else {
        $('#calendar').removeClass('d-block').addClass('d-none');
        showCalendar();
        clickCalendario = 0;
    }
});

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
let d = new Date();
let monthShow = d.getMonth();
let yearShow = d.getFullYear();

window.onload = () => {
    //Mes anterior
    $('#calendar caption span:first-child').click(() => {
        showCalendar(yearShow, monthShow - 1);
    });
    //Mes siguiente
    $('#calendar caption span:last-child').click(() => {
        showCalendar(yearShow, monthShow + 1);
    });
}

function showCalendar(year, month) {
    let now = new Date();
    let dayNow = now.getDate();

    if (year == undefined || month == undefined) {
        d = new Date();
    } else {
        if (month == 12) {
            month = 0;
            year++;
        }
        if (month == -1) {
            month = 11;
            year--;
        }
        d = new Date(year, month);
    }
    monthShow = d.getMonth();
    yearShow = d.getFullYear();
    let firstDayDate = new Date(d.getFullYear(), d.getMonth(), 1);
    //let firstDay = firstDayDate.getDate();
    let dayWeek = firstDayDate.getDay() + 7;
    let lastDayDate = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    let lastDay = lastDayDate.getDate();

    let route = $('#calendar').data('route');
    $('#calendar .month').html(months[monthShow] + ' ' + yearShow);
    $('#calendar tbody tr').remove();
    $('#calendar tbody').append('<tr></tr>');

    let last_cell = dayWeek + lastDay;
    let day = 0;

    for (let i = 1; i <= 42; i++) {
        if (i == dayWeek) {
            //Determinamos en que día empieza
            day = 1;
        }
        if (i < dayWeek || i >= last_cell) {
            //Celda vacía
            $('#calendar tbody tr:last-child').append('<td></td>');
        } else {
            //Mostramos el dia
            if (d.getDate() == day) {
                let dateTD = yearShow + '-' + (monthShow + 1) + '-' + day;
                $('#calendar tbody tr:last-child').append('<td id="' + dateTD + '" class="today d" style="background: red; color: white">' + day + '</td>');
                $('#' + dateTD).on('click', function () {
                    window.location.href = route + '/' + dateTD;
                });
            } else {
                let dateTD = yearShow + '-' + (monthShow + 1) + '-' + day;
                $('#calendar tbody tr:last-child').append('<td id="' + dateTD + '" class="d">' + day + '</td>');
                $('#' + dateTD).on('click', function () {
                    window.location.href = route + '/' + dateTD;
                });
            }
            day++;
        }
        //Cuando llegamos al final de la semana, iniciamos una columna nueva
        if (i % 7 == 0) {
            if (i > last_cell) {
                break;
            }
            $('#calendar tbody').append('<tr></tr>');
        }
    }
}

$(window).scroll(function () {
    if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').fadeIn();
    } else {
        $('.scroll-to-top').fadeOut();
    }
});
$('.scroll-to-top').click(function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 400);
});

$('#refresh-captcha').on('click', function (e) {
    e.preventDefault();
    let icon = $(this).find('i');
    let captcha = $('img.captcha-img');
    let config = captcha.data('refresh-config');
    icon.addClass('fa-spin');
    $.ajax({
        method: 'GET',
        url: '/get-captcha/' + config,
    }).done(function (response) {
        captcha.prop('src', response);
        icon.removeClass('fa-spin');
    });
});
